/**
 * Extracts the base layer ID from a given layer ID string.
 * The base layer ID is the substring before the first underscore.
 * e.g., "h173_l0_v3" becomes "h173"
 * @param {string} layerId - The full layer ID string (e.g., "hazard_123").
 * @returns {string} The base layer ID, or the original string if no underscore is present.
 */
export const getBaseLayerId = (layerId: string): string => {
  if (!layerId) return layerId
  return layerId.split('_')[0]
}

import {
  HazardCatalog,
  HazardDefinition,
  HazardScenario,
} from '@app/domains/hazards/types/hazard.types'
import type {
  ContextualCatalog,
  ContextualCategory,
  ContextualGroup,
  ContextualLayer,
  ElementCatalog,
  ElementCategory,
  ElementGroup,
  ElementItem,
} from '@app/domains/layers/types/layers.types'

export function flattenElementsFromCatalog(catalog: ElementCatalog): Array<{
  categoryKey: string
  category: ElementCategory
  group: ElementGroup
  asset: ElementItem
}> {
  const out: Array<{
    categoryKey: string
    category: ElementCategory
    group: ElementGroup
    asset: ElementItem
  }> = []
  for (const [categoryKey, category] of Object.entries(catalog)) {
    for (const group of category.groups ?? []) {
      for (const asset of group.assets ?? []) {
        out.push({ categoryKey, category, group, asset })
      }
    }
  }
  return out
}

export function flattenContextualFromCatalog(catalog: ContextualCatalog): Array<{
  categoryKey: string
  category: ContextualCategory
  group: ContextualGroup
  layer: ContextualLayer
}> {
  const out: Array<{
    categoryKey: string
    category: ContextualCategory
    group: ContextualGroup
    layer: ContextualLayer
  }> = []
  for (const [categoryKey, category] of Object.entries(catalog)) {
    for (const group of category.groups ?? []) {
      for (const layer of group.layers ?? []) {
        out.push({ categoryKey, category, group, layer })
      }
    }
  }
  return out
}

export function flattenHazardsFromCatalog(
  hazards: HazardCatalog,
): Array<{ hazard: HazardDefinition; scenario: HazardScenario }> {
  const out: Array<{ hazard: HazardDefinition; scenario: HazardScenario }> = []
  for (const hazard of hazards ?? []) {
    for (const scenario of hazard.scenarios ?? []) {
      out.push({ hazard, scenario })
    }
  }
  return out
}
